// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";

// const API_KEY = "YOUR_TMDB_API_KEY";

// const ActorDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [actor, setActor] = useState(null);
//   const [credits, setCredits] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchActor = async () => {
//       try {
//         setLoading(true);

//         const [actorRes, creditsRes] = await Promise.all([
//           fetch(`https://api.themoviedb.org/3/person/${id}?api_key=${API_KEY}`),
//           fetch(
//             `https://api.themoviedb.org/3/person/${id}/combined_credits?api_key=${API_KEY}`
//           ),
//         ]);

//         const actorData = await actorRes.json();
//         const creditsData = await creditsRes.json();

//         setActor(actorData);
//         setCredits(creditsData.cast || []);
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchActor();
//   }, [id]);

//   const movies = useMemo(
//     () =>
//       credits
//         .filter((item) => item.media_type === "movie")
//         .sort((a, b) => b.popularity - a.popularity),
//     [credits]
//   );

//   const tvShows = useMemo(
//     () =>
//       credits
//         .filter((item) => item.media_type === "tv")
//         .sort((a, b) => b.popularity - a.popularity),
//     [credits]
//   );

//   const knownFor = useMemo(() => {
//     return [...credits]
//       .sort((a, b) => b.popularity - a.popularity)
//       .slice(0, 10);
//   }, [credits]);

//   const getAge = (birthday, deathday) => {
//     if (!birthday) return "-";

//     const birth = new Date(birthday);
//     const end = deathday ? new Date(deathday) : new Date();

//     let age = end.getFullYear() - birth.getFullYear();

//     const month = end.getMonth() - birth.getMonth();

//     if (month < 0 || (month === 0 && end.getDate() < birth.getDate())) {
//       age--;
//     }

//     return age;
//   };

//   if (loading)
//     return (
//       <div
//         style={{
//           color: "#fff",
//           textAlign: "center",
//           padding: "100px",
//           fontSize: "25px",
//         }}
//       >
//         Loading...
//       </div>
//     );

//   return (
//     <div
//       style={{
//         background: "#111",
//         minHeight: "100vh",
//         color: "#fff",
//         padding: "40px",
//       }}
//     >
//       {/* ================= HERO ================= */}

//       <div
//         style={{
//           display: "flex",
//           gap: "40px",
//           flexWrap: "wrap",
//           marginBottom: "60px",
//         }}
//       >
//         <img
//           src={
//             actor?.profile_path
//               ? `https://image.tmdb.org/t/p/w500${actor.profile_path}`
//               : "https://via.placeholder.com/300x450?text=No+Image"
//           }
//           alt={actor?.name}
//           style={{
//             width: "280px",
//             borderRadius: "12px",
//           }}
//         />

//         <div style={{ flex: 1 }}>
//           <h1>{actor?.name}</h1>

//           <p>
//             <strong>Age:</strong> {getAge(actor?.birthday, actor?.deathday)}
//           </p>

//           {actor?.birthday && (
//             <p>
//               <strong>Birthday:</strong> {actor.birthday}
//             </p>
//           )}

//           {actor?.deathday && (
//             <p>
//               <strong>Died:</strong> {actor.deathday}
//             </p>
//           )}

//           <p>
//             <strong>Place of Birth:</strong> {actor?.place_of_birth || "-"}
//           </p>

//           <p>
//             <strong>Known For:</strong> {actor?.known_for_department}
//           </p>

//           <p>
//             <strong>Popularity:</strong> {actor?.popularity?.toFixed(1)}
//           </p>

//           <br />

//           <h2>Biography</h2>

//           <p style={{ lineHeight: 1.8 }}>
//             {actor?.biography || "No biography available."}
//           </p>
//         </div>
//       </div>

//       {/* ================= KNOWN FOR ================= */}

//       <h2 style={{ marginBottom: "20px" }}>Known For</h2>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fill,minmax(170px,1fr))",
//           gap: "20px",
//           marginBottom: "60px",
//         }}
//       >
//         {knownFor.map((item) => (
//           <div
//             key={`${item.media_type}-${item.id}`}
//             style={{ cursor: "pointer" }}
//             onClick={() =>
//               navigate(
//                 item.media_type === "movie"
//                   ? `/movie/${item.id}`
//                   : `/tv/${item.id}`
//               )
//             }
//           >
//             <img
//               src={
//                 item.poster_path
//                   ? `https://image.tmdb.org/t/p/w500${item.poster_path}`
//                   : "https://via.placeholder.com/200x300?text=No+Image"
//               }
//               alt={item.title || item.name}
//               style={{
//                 width: "100%",
//                 borderRadius: "10px",
//               }}
//             />

//             <h4>{item.title || item.name}</h4>

//             <p>
//               {item.release_date?.slice(0, 4) ||
//                 item.first_air_date?.slice(0, 4)}
//             </p>
//           </div>
//         ))}
//       </div>

//       {/* ================= MOVIES ================= */}

//       <h2 style={{ marginBottom: "20px" }}>Movies</h2>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fill,minmax(170px,1fr))",
//           gap: "20px",
//           marginBottom: "70px",
//         }}
//       >
//         {movies.map((movie) => (
//           <div
//             key={movie.id}
//             style={{ cursor: "pointer" }}
//             onClick={() => navigate(`/movie/${movie.id}`)}
//           >
//             <img
//               src={
//                 movie.poster_path
//                   ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
//                   : "https://via.placeholder.com/200x300?text=No+Image"
//               }
//               alt={movie.title}
//               style={{
//                 width: "100%",
//                 borderRadius: "10px",
//               }}
//             />

//             <h4>{movie.title}</h4>

//             <p>{movie.release_date?.slice(0, 4)}</p>
//           </div>
//         ))}
//       </div>

//       {/* ================= TV SHOWS ================= */}

//       <h2 style={{ marginBottom: "20px" }}>TV Shows</h2>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fill,minmax(170px,1fr))",
//           gap: "20px",
//         }}
//       >
//         {tvShows.map((show) => (
//           <div
//             key={show.id}
//             style={{ cursor: "pointer" }}
//             onClick={() => navigate(`/tv/${show.id}`)}
//           >
//             <img
//               src={
//                 show.poster_path
//                   ? `https://image.tmdb.org/t/p/w500${show.poster_path}`
//                   : "https://via.placeholder.com/200x300?text=No+Image"
//               }
//               alt={show.name}
//               style={{
//                 width: "100%",
//                 borderRadius: "10px",
//               }}
//             />

//             <h4>{show.name}</h4>

//             <p>{show.first_air_date?.slice(0, 4)}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ActorDetails;
import styled from "styled-components";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const API_KEY = "5cb3971f2ed6c001df1ae772ee291eb2";

const ActorDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [actor, setActor] = useState(null);
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const getActor = async () => {
      try {
        setLoading(true);

        const [personRes, creditsRes] = await Promise.all([
          fetch(`https://api.themoviedb.org/3/person/${id}?api_key=${API_KEY}`),
          fetch(
            `https://api.themoviedb.org/3/person/${id}/combined_credits?api_key=${API_KEY}`
          ),
        ]);

        const person = await personRes.json();
        const credit = await creditsRes.json();

        setActor(person);
        setCredits(credit.cast || []);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    getActor();
  }, [id]);

  const getAge = (birthday, deathday) => {
    if (!birthday) return "-";

    const birth = new Date(birthday);
    const end = deathday ? new Date(deathday) : new Date();

    let age = end.getFullYear() - birth.getFullYear();

    const month = end.getMonth() - birth.getMonth();

    if (month < 0 || (month === 0 && end.getDate() < birth.getDate())) {
      age--;
    }

    return age;
  };

  const movies = useMemo(() => {
    return credits
      .filter((item) => item.media_type === "movie")
      .sort((a, b) => b.popularity - a.popularity);
  }, [credits]);

  const tvShows = useMemo(() => {
    return credits
      .filter((item) => item.media_type === "tv")
      .sort((a, b) => b.popularity - a.popularity);
  }, [credits]);

  const knownFor = useMemo(() => {
    return [...credits]
      .sort((a, b) => b.popularity - a.popularity)
      .slice(0, 10);
  }, [credits]);
  console.log(actor);
  if (loading) {
    return <Loading>Loading Actor...</Loading>;
  }

  return (
    <Container>
      <Hero
        style={{
          backgroundImage: actor?.profile_path
            ? `url(https://image.tmdb.org/t/p/original${actor.profile_path})`
            : "none",
        }}
      >
        <Overlay />

        <HeroContent>
          <ProfileImage
            src={
              actor?.profile_path
                ? `https://image.tmdb.org/t/p/w500${actor.profile_path}`
                : "/no-image.png"
            }
          />

          <Info>
            <Name>{actor?.name}</Name>

            <Department>{actor?.known_for_department}</Department>

            <Stats>
              <Stat>
                <strong>Age</strong>
                <span>{getAge(actor?.birthday, actor?.deathday)}</span>
              </Stat>

              <Stat>
                <strong>Birthday</strong>
                <span>{actor?.birthday || "-"}</span>
              </Stat>

              <Stat>
                <strong>Birth Place</strong>
                <span>{actor?.place_of_birth || "-"}</span>
              </Stat>

              <Stat>
                <strong>Popularity</strong>
                <span>{actor?.popularity?.toFixed(1)}</span>
              </Stat>
            </Stats>

            <Bio>{actor?.biography || "No biography available."}</Bio>
          </Info>
        </HeroContent>
      </Hero>

      {/* Known For */}

      <Section>
        <SectionTitle>Known For</SectionTitle>

        <Grid>
          {knownFor.map((item) => (
            <Card
              key={`${item.media_type}-${item.id}`}
              onClick={() =>
                navigate(
                  item.media_type === "movie"
                    ? `/movie/${item.id}`
                    : `/tv/${item.id}`
                )
              }
            >
              <Poster
                src={
                  item.poster_path
                    ? `https://image.tmdb.org/t/p/w500${item.poster_path}`
                    : "/no-image.png"
                }
              />

              <CardTitle>{item.title || item.name}</CardTitle>

              <CardYear>
                {item.release_date?.slice(0, 4) ||
                  item.first_air_date?.slice(0, 4)}
              </CardYear>
            </Card>
          ))}
        </Grid>
      </Section>

      {/* Movies */}

      <Section>
        <SectionTitle>Movies</SectionTitle>

        <Grid>
          {movies.map((movie) => (
            <Card key={movie.id} onClick={() => navigate(`/movie/${movie.id}`)}>
              <Poster
                src={
                  movie.poster_path
                    ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
                    : "/no-image.png"
                }
              />

              <CardTitle>{movie.title}</CardTitle>

              <CardYear>{movie.release_date?.slice(0, 4)}</CardYear>
            </Card>
          ))}
        </Grid>
      </Section>

      {/* TV Shows */}

      <Section>
        <SectionTitle>TV Shows</SectionTitle>

        <Grid>
          {tvShows.map((show) => (
            <Card key={show.id} onClick={() => navigate(`/tv/${show.id}`)}>
              <Poster
                src={
                  show.poster_path
                    ? `https://image.tmdb.org/t/p/w500${show.poster_path}`
                    : "/no-image.png"
                }
              />

              <CardTitle>{show.name}</CardTitle>

              <CardYear>{show.first_air_date?.slice(0, 4)}</CardYear>
            </Card>
          ))}
        </Grid>
      </Section>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #090909;
  color: #fff;
`;

const Hero = styled.section`
  position: relative;
  width: 100%;
  min-height: 700px;
  display: flex;
  align-items: flex-end;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  mask-image: linear-gradient(
    to bottom,
    transparent,
    black 20%,
    black 75%,
    transparent
  );
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;

  background: linear-gradient(
    to top,
    #090909 5%,
    rgba(9, 9, 9, 0.85) 35%,
    rgba(9, 9, 9, 0.45) 65%,
    rgba(9, 9, 9, 0.2) 100%
  );

  backdrop-filter: blur(18px);
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;

  width: 100%;
  max-width: 1500px;

  margin: auto;

  display: flex;
  gap: 50px;

  align-items: flex-end;

  padding: 120px 60px 70px;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 80px 25px;
  }
`;

const ProfileImage = styled.img`
  width: 320px;
  border-radius: 18px;
  overflow: hidden;

  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6), 0 0 30px rgba(184, 149, 100, 0.15);

  object-fit: cover;

  transition: 0.35s;

  &:hover {
    transform: translateY(-6px);
  }

  @media (max-width: 768px) {
    width: 260px;
  }
`;

const Info = styled.div`
  flex: 1;
`;

const Name = styled.h1`
  font-size: 58px;
  font-weight: 700;
  margin-bottom: 15px;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 40px;
  }
`;

const Department = styled.div`
  display: inline-flex;

  align-items: center;

  padding: 10px 18px;

  border-radius: 30px;

  background: #b89564;

  color: #111;

  font-weight: 600;

  margin-bottom: 35px;
`;

const Stats = styled.div`
  display: flex;

  flex-wrap: wrap;

  gap: 18px;

  margin-bottom: 35px;
`;

const Stat = styled.div`
  min-width: 170px;

  background: #161616;

  border: 1px solid rgba(255, 255, 255, 0.05);

  border-radius: 14px;

  padding: 18px;

  transition: 0.3s;

  strong {
    display: block;

    color: #b89564;

    margin-bottom: 10px;

    font-size: 14px;

    font-weight: 600;
  }

  span {
    color: #eee;

    font-size: 17px;

    line-height: 1.5;
  }

  &:hover {
    border-color: #b89564;

    transform: translateY(-5px);
  }
`;

const Bio = styled.p`
  color: #d2d2d2;

  line-height: 1.9;

  font-size: 16px;

  max-width: 950px;
`;

const Section = styled.section`
  width: 100%;

  max-width: 1500px;

  margin: auto;

  padding: 70px 60px;

  @media (max-width: 768px) {
    padding: 50px 20px;
  }
`;

const SectionTitle = styled.h2`
  position: relative;

  width: fit-content;

  font-size: 34px;

  margin-bottom: 35px;

  &::after {
    content: "";

    position: absolute;

    left: 0;
    bottom: -10px;

    width: 70%;

    height: 4px;

    border-radius: 10px;

    background: #b89564;
  }
`;

const Grid = styled.div`
  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));

  gap: 28px;
`;

const Card = styled.div`
  cursor: pointer;

  transition: 0.35s;

  &:hover {
    transform: translateY(-8px);
  }

  &:hover img {
    transform: scale(1.06);

    box-shadow: 0 18px 45px rgba(184, 149, 100, 0.25);
  }
`;

const Poster = styled.img`
  width: 100%;

  aspect-ratio: 2/3;

  object-fit: cover;

  border-radius: 14px;

  transition: 0.35s;

  background: #222;
`;

const CardTitle = styled.h3`
  margin-top: 15px;

  color: white;

  font-size: 17px;

  font-weight: 600;

  overflow: hidden;

  display: -webkit-box;

  -webkit-line-clamp: 2;

  -webkit-box-orient: vertical;
`;

const CardYear = styled.p`
  color: #b89564;

  margin-top: 8px;

  font-size: 15px;
`;

const Loading = styled.div`
  width: 100%;

  height: 100vh;

  display: flex;

  justify-content: center;

  align-items: center;

  color: white;

  font-size: 30px;

  font-weight: 600;
`;

export default ActorDetails;
